import { render } from "./HospitalFilter.vue?vue&type=template&id=0a541559"
const script = {}

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/navbarFilter/HospitalFilter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0a541559"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0a541559', __exports__)) {
    console.log('reload')
    api.reload('0a541559', __exports__)
  }
  
  module.hot.accept("./HospitalFilter.vue?vue&type=template&id=0a541559", () => {
    console.log('re-render')
    api.rerender('0a541559', render)
  })

}


export default __exports__